import { EditInvitedCompanyNameFormValues } from '@/components/misc/EditInvitedCompanyNameButton/EditInvitedCompanyNameModal/types'

export const EDIT_INVITED_COMPANY_NAME_FORM_FIELDS: Record<
  keyof EditInvitedCompanyNameFormValues,
  keyof EditInvitedCompanyNameFormValues
> = {
  companyName: 'companyName',
}
